var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcontable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7071 11.293L19.5311 7.11697C15.3716 2.95743 8.62843 2.95743 4.46893 7.11697L0.292887 11.293C-0.0976289 11.6835 -0.0976289 12.3167 0.292887 12.7072L4.46889 16.8832C8.62843 21.0427 15.3716 21.0427 19.5311 16.8832L23.7071 12.7072C24.0977 12.3167 24.0977 11.6835 23.7071 11.293ZM18.1169 15.469C14.7384 18.8474 9.26162 18.8474 5.88315 15.469L2.41421 12.0001L5.88311 8.53119C9.26157 5.15272 14.7384 5.15272 18.1169 8.53119L21.5858 12.0001L18.1169 15.469Z",
    fill: "#0E60B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7C9.23875 7 7 9.2387 7 12C7 14.7613 9.23875 17 12 17C14.7613 17 17 14.7613 17 12C17 9.23875 14.7613 7 12 7ZM12 15C10.3433 15 9.00002 13.6567 9.00002 12C9.00002 10.3433 10.3433 9.00002 12 9.00002C13.6567 9.00002 15 10.3433 15 12C15 13.6567 13.6567 15 12 15Z",
    fill: "#0E60B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcontable);
export default __webpack_public_path__ + "static/media/eyeIcontable.1e57fc4984953faf0912e6e938817a3c.svg";
export { ForwardRef as ReactComponent };